// List of major Steamship Lines (SSL)
export const STEAMSHIP_LINES = [
  'Maersk',
  'MSC (Mediterranean Shipping Company)',
  'CMA CGM',
  'COSCO Shipping',
  'Hapag-Lloyd',
  'ONE (Ocean Network Express)',
  'Evergreen Marine',
  'Yang Ming Marine Transport',
  'HMM (Hyundai Merchant Marine)',
  'ZIM Integrated Shipping Services',
  'OOCL (Orient Overseas Container Line)',
  'APL (American President Lines)',
  'PIL (Pacific International Lines)',
  'Wan Hai Lines',
  'TS Lines',
  'Matson Navigation',
  'Crowley Maritime',
  'Hamburg Süd',
  'Safmarine',
  'Sealand - A Maersk Company',
  'Arkas Line',
  'KMTC (Korea Marine Transport Co.)',
  'Sinokor Merchant Marine',
  'SM Line',
  'Namsung Shipping',
  'Heung-A Shipping',
  'X-Press Feeders',
  'Regional Container Lines (RCL)',
  'COSCO Shipping Lines',
  'China Shipping Container Lines (CSCL)',
  'Seaboard Marine',
  'Mediterranean Shipping Company USA',
  'Evergreen Line',
  'Turkon Line',
  'NileDutch',
  'Tropical Shipping',
  'King Ocean Services',
  'Swire Shipping',
  'Other'
].sort();
